import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  // --- Brand Color Palette ---
  palette: {
    primary: {
      main: '#001F3F', // Navy Blue
      light: '#6495ED', // Sky Blue
      dark: '#000f1f',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#6495ED', // Sky Blue (Used for accents/buttons)
      contrastText: '#001F3F', // Navy Blue text on Sky Blue
    },
    background: {
      default: '#FFFFFF',
      paper: '#F8F8FF', // Glossy Light
    },
    text: {
      primary: '#333333',
      secondary: '#666666',
    },
  },
  // --- Typography (Font) ---
  typography: {
    fontFamily: 'Poppins, sans-serif',
    h1: {
      fontWeight: 800,
      fontSize: '3.5rem',
    },
    h2: {
      fontWeight: 800,
    },
    button: {
      fontWeight: 600,
      textTransform: 'none', // Prevent ALL CAPS buttons
    },
  },
  // --- Component Overrides for Glossy/Silver Look ---
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          // Implementing the glossy look with linear-gradient and border
          background: 'linear-gradient(180deg, #FFFFFF 0%, #F8F8FF 100%)',
          borderBottom: '1px solid #C0C0C0', // Silver border
          boxShadow: 'none', // Remove default MUI shadow
          zIndex: 1000,
        },
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true, // Remove default elevation for a flatter look
      },
      styleOverrides: {
        root: {
          borderRadius: 5,
        },
        containedPrimary: {
          // Adding custom shadow for the "Glossy" feel on primary buttons
          boxShadow: '0 4px 10px rgba(0, 31, 63, 0.2)',
          '&:hover': {
            boxShadow: '0 4px 15px rgba(100, 149, 237, 0.5)',
          },
        },
        outlinedPrimary: {
            // Outlined buttons use Navy border as defined previously
            border: '2px solid #001F3F',
        }
      }
    }
  }
});

export default theme;